module.exports = __webpack_public_path__ + "media/images/fake/005-5accadd8ba19ba0b41ddf5988507a94e.jpg";